document.addEventListener('DOMContentLoaded', () => {
    var len = document.querySelectorAll(".product-desc-5-item").length;
    const isShowDescriptionSeeMore = false;
    // var pswiper = new Swiper('.product-desc-6', {
    //   slidesPerView:len,
    //   spaceBetween: 20,
    //   breakpoints: { 
    //     1000: {
    //         slidesPerView: 2,
    //         scrollbar: {
    //           el: ".new-carousel-scrollbar",
    //         },
    //     },
    //     590: {
    //         slidesPerView: 1,
    //         scrollbar: {
    //           el: ".new-carousel-scrollbar",
    //         },
    //     }
    //   }   
    // });
    // if(window.screen.width>1000){
    //   pswiper.allowTouchMove= false;
    // }

      $(".product-discount-full__btn-copy").click((e) => {
        e.currentTarget.dataset.success ="true";
        const text = $(".product-discount-full__code-text>h5>span").html();
        // copy
        try {
          navigator.clipboard.writeText(val).then(res => {
            resolve();
          }).catch(e => {
            reject(e);
          });
        } catch (error) {
          const input = document.createElement('input');
          input.setAttribute('readonly', 'readonly');
          input.setAttribute('value', text);
          document.body.appendChild(input);
          input.setSelectionRange(0, 9999);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        // hide success icon
        setTimeout(() => {
          e.currentTarget.dataset.success ="false";
        }, 2000);
      });

      // Bottom product-navbar ATC → main buy-box button (must run before early return below)
      $(".productadd_btn").click(function(){
        var mainBtn = document.querySelector('.buy-buttons-block [data-testid="standalone-add-to-cart"], product-form-component .add-to-cart-button:not(.sticky-add-to-cart__button)');
        if (mainBtn && !mainBtn.disabled) {
          mainBtn.click();
        }
      });

      if (!isShowDescriptionSeeMore) return;
      if($(window).width()>1000){
        var h = parseInt($(".product_desc>div").css("lineHeight"))*3;
        $(".product_desc").height(h);
        if($(".product_desc>div").height()>$(".product_desc").height()){
          $(".product_moredesc").show();
        }else{
          $(".product_moredesc").hide();
        }
      }
      $(window).resize(function() {
        var h = parseInt($(".product_desc>div").css("lineHeight"))*3;
        $(".product_desc").height(h);
        if($(".product_desc>div").height()>$(".product_desc").height()){
          $(".product_moredesc").show();
        }else{
          $(".product_moredesc").hide();
        }
      });
  
      $(".product_moredesc").click(function(){
        $(".product_desc").height("auto");
        $(this).hide();
      })
      



    var optionLists = $('.option--color .clickyboxes li a')
    var discountLists = $('.product_variant_discount')
    var codeLists = $('.product-discount-full__code-text h5 span')

    function discountChange() {
      if(discountLists.length > 0) {
        optionLists.each(function(index, item) {
          var option = $(item)
    
          if(option.hasClass('active')) {
            var value = option.data('value');
    
            discountLists.each(function(num, discount) {
              var discount = $(discount)
    
              var variantTitle = discount.data('value')
    
              if(variantTitle === value) {
                discount.removeClass('hide')
                $('.product_variant_code').eq(num).removeClass('hide')
              } else {
                discount.addClass('hide')
                $('.product_variant_code').eq(num).addClass('hide')
              }
            })
          }
        })
      }
      
    }

    discountChange()
   
    $('.option--color .clickyboxes li a').click(function() {
      setTimeout(function() {
        discountChange()
      }, 0)
    })


    // 复制函数
    function copyToClip2(content) {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", content); 
         document.body.appendChild(aux); 
         aux.select();
         document.execCommand("copy"); 
         document.body.removeChild(aux);
    }

    $(".product-discount-full__btn-copy").click(function(){

      if (codeLists.length > 0) {
        codeLists.each(function(num, item) {
          var code = $(item)

          if(code.hasClass('hide')) {
            return
          } else {
            let text = code.text()
            copyToClip2(text);
          }
        })
      }
    });

    //自定义payment-button触发加购按钮
    $('.product-btn_box .custom_payment_btn').on('click',function(e){
      $('.product-btn_box .custom_payment_btn').siblings('.shopify-payment-button').find('.shopify-payment-button__button').trigger('click');
    })

    document.querySelectorAll('.product-price_add-box .sale_tips--has-now-price').forEach(function (tips) {
      const box = tips.closest('.product-price_add-box');
      if (box) box.classList.add('product-price_add-box--has-now-price');

      const priceEl = tips.parentElement && tips.parentElement.querySelector('product-price .price, .product-price');
      if (priceEl) {
        priceEl.classList.add('price-line');
        const productPrice = priceEl.closest('.product-price');
        if (productPrice) productPrice.classList.add('price-line');
        const productPriceEl = priceEl.closest('product-price');
        if (productPriceEl) productPriceEl.classList.add('product-price--has-now-price');
      }
    });


  
});
